<template>
  <div class="goods-box">
    <el-button
      type="primary"
      size="mini"
      @click="handleAdd"
      style="margin-top: 10px"
      >新增</el-button
    >
    <el-divider></el-divider>
    <el-table
      ref="tableRef"
      :data="goodsData"
      highlight-current-row
      style="width: 100%; margin-top: 10px"
      :max-height="maxHeight"
    >
      <!-- <el-table-column type="index" label="序号" width="80" align="center" /> -->
      <el-table-column type="sort" label="序号" width="140" align="center">
        <template slot-scope="scope">
          <div class="merchant-name">
            <span class="name">{{ scope.row.serialNumber }}</span>
            <span v-if="scope.row.id">
              <i
                class="el-icon-edit"
                style="margin-left: 10px"
                @click="handleClickSort(scope.row)"
              ></i>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="分类名称" align="center" prop="classifyName">
      </el-table-column>
      <el-table-column label="商品数量" align="center" prop="goodsNum">
      </el-table-column>
      <el-table-column prop="updateBy" label="更新人" align="center" />
      <el-table-column prop="updateTime" label="更新时间" align="center" />
      <el-table-column label="操作" align="center" width="120" fixed="right">
        <template slot-scope="scope">
          <div class="operation">
            <el-link
              :underline="false"
              @click="handleEdit(scope.row)"
              style="margin-bottom: 8px"
              >选择商品</el-link
            >
            <el-link
              :underline="false"
              @click="handleDelete(scope.row, scope.$index)"
              >删除</el-link
            >
          </div>
          <!-- <p
            @click="handleEdit(scope.row)"
            style="cursor: pointer; margin-right: 10px"
          >
            选择商品
          </p>
          <p
            @click="handleDelete(scope.row, scope.$index)"
            :style="{
              color: 'red',
              cursor: 'pointer',
            }"
          >
            删除
          </p> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增/编辑 -->
    <ClinicsCategoryGoodsSelectDlg
      ref="addGoodsRef"
      @refreshList="getGoodsList"
      :sourceParentPage="'clinicsCategory'"
    />
    <!-- 编辑分类 -->
    <editNameAndSort ref="editNameAndSort" @refreshList="getGoodsList" />
  </div>
</template>

<script>
import avater from "/public/img/default.png";
import ClinicsCategoryGoodsSelectDlg from "./clinicsCategoryGoodsSelectDlg";
import editNameAndSort from "./editNameAndSort";
import {
  goodsClinicEssentialBasicsConfigsList,
  goodsClinicEssentialBasicsConfigsDelete,
} from "@/api/recommendationHome";

export default {
  components: {
    ClinicsCategoryGoodsSelectDlg,
    editNameAndSort,
  },
  data() {
    return {
      avater: avater,
      goodsData: [],
      showShop: false,
      maxHeight: 0,
      showProductCoverSetting: false,
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getWindowView();
    this.getGoodsList();
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  methods: {
    handleClickSort(row) {
      this.$refs.editNameAndSort.showEdit(row, "goods");
    },
    getWindowView() {
      let innerHeight = window.innerHeight; //获取页面高度
      let headHeight = 300;
      let maxHeight = innerHeight - headHeight;
      this.maxHeight = maxHeight;
      // console.log( this.maxHeight)
    },
    getGoodsList() {
      goodsClinicEssentialBasicsConfigsList().then((res) => {
        if (res.code == 0) {
          this.goodsData = res.data;
        }
      });
    },
    handleAdd() {
      this.$refs.editNameAndSort.showAdd();
      // // 滚动到底部
      // this.$nextTick(() => {
      //   this.$refs.tableRef.bodyWrapper.scrollTop =
      //     this.$refs.tableRef.bodyWrapper.scrollHeight;
      // });
    },
    // 编辑分类
    handleEditCategory(row) {},
    handleEdit(row) {
      this.$refs.addGoodsRef.publicOpen(row);
    },
    handleDelete(row, index) {
      if (row.add) {
        this.goodsData.splice(index, 1);
        return;
      }
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return goodsClinicEssentialBasicsConfigsDelete(row.id);
        })
        .then(() => {
          this.getGoodsList();
          this.$message.success("删除成功");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.goods-box {
  .goods-info {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    &-left {
      width: 60px;
      height: 60px;
      margin-right: 10px;
    }
    &-right {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 260px;

      .text-ellipsis {
        max-width: 250px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    p {
      margin: 0;
      height: 18px;
    }
    .color-26 {
      color: #262626;
    }
  }
}
.operation {
  display: flex;
  flex-direction: column;
}
</style>
